import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    lengthPwd: false, // 密码长度校验
    iconPwd: false, // 密码大小写、数字、特殊字符校验
    charsPwd: false, // 字母、数字、特殊字符位数限制
    changeDate: 0, // 开始时间、结束时间标识
  },
  mutations: {

  },
  actions: {

  },
  modules: {

  }
})



// WEBPACK FOOTER //
// ./src/store/index.js